import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import Helper from 'src/helper/Helper';
import Pagination from "src/component/Global/Pagination"
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import ReusableDiv from 'src/helper/ReusableDiv';
import ContentTabCommonSorting from './ContentTabCommonSorting';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';

const SiteTab = () => {
    const [list, setList] = useState([]);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [{ }, { get_home_page_content }] = useHomePageContentStore();
    const [searchParams] = useSearchParams();
    const [__check] = useAxiosIndicatorCheck();
    const [listObj, setListObj] = useState({ pageCount: 0, page: 1, limit: 20, sortBy: 'Relevance' });
    const { homePageAllTabs } = Constants;

    useEffect(() => {
        const fetchInitialData = async () => {
            await fetchAPiCall(true);
            setFirstServerCall(false);
        };
        fetchInitialData();
    }, []);

    useEffect(() => {
        if (!firstServerCall) {
            fetchAPiCall();
        }
    }, [listObj.page, listObj.limit, listObj.sortBy]);

    const handlePageClick = (data) => {
        const newPage = data.selected + 1;
        setListObj({ ...listObj, page: newPage });
        Helper.scrollTop();
    };

    const setPageLimit = (event) => {
        const newLimit = Number(event.target.value);
        setListObj({ ...listObj, limit: newLimit, page: 1 });
    };

    const fetchAPiCall = async (defaultStart = false) => {
        __set('CONTENT_API_CALL');
        const searchKeyword = searchParams.get('search');
        const data = await get_home_page_content({
            pageNumber: defaultStart ? 1 : listObj.page,
            pageSize: listObj.limit,
            orderBy: listObj.sortBy,
            searchTerm: searchKeyword,
            contentType: homePageAllTabs.SITE.contentType
        });

        const total = data[homePageAllTabs.SITE.contentType]?.totalCount || 0;
        const content = data[homePageAllTabs.SITE.contentType]?.webContentView || [];
        setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
        setList(content);
        __remove('CONTENT_API_CALL');
    };

    const onFilter = (e) => {
        const newSortBy = e.target.value;
        setListObj({ ...listObj, sortBy: newSortBy })
    };

    return (
        <div id="contentTypeOther" className="tab-pane fade active in">
            <div className='other-content-wrapper'>
                <div className='bs5 row'>
                    <div className='col-lg-9 tab-data'>
                        <div className='all-content'>

                            <ContentTabCommonSorting onFilter={onFilter} headerNme={homePageAllTabs.SITE.tabHeader} dataLength={list.length} />

                            <hr />
                            {__check(['CONTENT_API_CALL', 'ALL_CONTENT_COUNT_API_CALL']).status ? <AxiosIndicatorRunTimeLoader /> :
                                <div className='position-relative'>
                                    <div className='all-content-body'>
                                        {list.length > 0 ? (
                                            list.map((v, i) => (
                                                <div key={i} className='all-content-body-item'>
                                                    <div className='bs5 row'>
                                                        <div className='col-lg-12'>
                                                            <div className='font-16 text-blue2 font-bold mb-1'>
                                                                <a href={v?.url} target='_blank' rel='noreferrer'>{v.name}</a>
                                                            </div>
                                                            <div className='ellipses'>{v.shortDescription}</div>
                                                            {v.shortDescription?.length > 140 && (
                                                                <a href={v?.url} className="text-blue2 d-block" target='_blank' rel='noreferrer'>
                                                                    Read More
                                                                </a>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </div>
                                            ))
                                        ) : (
                                            !firstServerCall && searchParams.get('search') && (
                                                <NoResultContent message={`No Results Found for <b>"${searchParams.get('search')}"</b>`} />
                                            )
                                        )}
                                    </div>
                                    {list.length > 0 && (
                                        <div className="pagination-row mt-5">
                                            <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                    </div>
                    <div className='col-lg-3 tab-sidebar'>
                        {ReusableDiv.newsLetterAd()}
                        <div className='looking-for'>
                            <div className='looking-title font-24 font-bold font-apercu mb-2'>Looking for Products?</div>
                            <a href='#' className="text-blue2 d-block">View Our New Product Introductions</a>
                            <a href='#' className="text-blue2 d-block">View Our Current Promotions</a>
                            <hr className='my-2' />
                            <div>
                                Today, we can design, make, supply and deliver for customers of every size in every corner of the world—whether your product is still a notion on a napkin, in mass production, or at any point in between.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SiteTab;
